import { z } from 'zod';

const giftAmountSchema = z.union([z.literal(1), z.literal(3), z.literal(6), z.literal(12)], {
  error: 'Gift amount is required',
});

const recipientSchema = z.object({
  firstName: z.string().min(1, { message: 'First name is required' }),
  lastName: z.string().min(1, { message: 'Last name is required' }),
  email: z.email({ message: 'Invalid email address' }),
  quantity: giftAmountSchema,
  type: z.enum(['SUBSCRIPTION']),
  message: z.string().max(160, { message: 'Personal message must be 160 characters or less' }).optional(),
});

export const giftFormSchema = z.object({
  recipients: z
    .array(recipientSchema)
    .min(1, { message: 'At least one recipient is required' })
    .max(10, { message: 'Maximum of 10 recipients allowed' }),
  sender: z.object({
    firstName: z.string().min(1, { message: 'First name is required' }),
    lastName: z.string().min(1, { message: 'Last name is required' }),
    email: z.email({ message: 'Invalid email address' }),
    anonymousId: z.string().nullish(),
  }),
});

export type GiftAmount = z.infer<typeof giftAmountSchema>;
export type Recipient = z.infer<typeof recipientSchema>;
export type GiftFormData = z.infer<typeof giftFormSchema>;

export const GIFT_RECIPIENTS_NAME = {
  1: 'First recipient',
  2: 'Second recipient',
  3: 'Third recipient',
  4: 'Fourth recipient',
  5: 'Fifth recipient',
  6: 'Sixth recipient',
  7: 'Seventh recipient',
  8: 'Eighth recipient',
  9: 'Ninth recipient',
  10: 'Tenth recipient',
};

export const GIFT_AMOUNT_PRICES: Record<GiftAmount, number> = {
  1: 10,
  3: 30,
  6: 60,
  12: 120,
};

export const GIFT_AMOUNT_OPTIONS: { value: GiftAmount; label: string }[] = [
  { value: 3, label: '3 months - $30' },
  { value: 6, label: '6 months - $60' },
  { value: 12, label: '12 months - $120' },
];

export const GiftCampaignEnums = {
  BLACKFRIDAY_2025: 'BLACKFRIDAY_2025',
} as const;

export type GiftCampaignName = (typeof GiftCampaignEnums)[keyof typeof GiftCampaignEnums];
